import { useRouterStore } from '@/store/router';
import { useAppStore } from '@/store/store';
import { useUserStore } from '@/store/user';
import { hasSubdomain } from '@/helpers/util';

export const validateRoute = async (to, from, next) => {
  await validateAuth(to, from, next);
  await validateFeature(to, from, next);
  await validateSubdomain(to, from, next);
};

// check if user data is instantiated. If yes user must be logged in, else check if it can be fetched. this also checks if keycloak is still set.
const validateAuth = async (to, from, next) => {
  const userStore = useUserStore();

  if (!userStore.userLoggedIn) {
    await userStore.updateUser();
  }

  if (to.meta.requiresAuth && !userStore.userLoggedIn) {
    next({ path: '/login' });
  }
};

const validateFeature = async (to, from, next) => {
  const appStore = useAppStore();

  if (to.meta.feature && !appStore.feature(to.meta.feature)) {
    next({ path: '/' });
  }
};

const validateSubdomain = async (to, from, next) => {
  if (!hasSubdomain() && to.path !== '/') {
    next({ path: '/' });
  }
};

export const updateRouterHistory = async (to, from, next) => {
  const routerStore = useRouterStore();
  const { pushRoute } = routerStore;
  pushRoute(to);

  next();
};
